<template>
  <div class="hello">
    <van-nav-bar v-if="isWx==1" title="诊断测评" left-arrow @click-left="onClickLeft" fixed/>
    <van-nav-bar v-else title="诊断测评" fixed/>
    <div class="subjectlist">
      <div class="title">
        <h2>生物安全测评</h2>
      </div>
      <ul class="subject-BioSafety">
        <li @click="subject('pasture')">
          <img src="../../assets/subjectimg/icon01.png" alt="">
          <span>防控非洲猪瘟牧场测评</span>
        </li>
        <li @click="subject('laboratory')">
          <img src="../../assets/subjectimg/icon02.png" alt="">
          <span>防控非洲猪瘟实验室环境测评</span>
        </li>
      </ul>
      <div class="title">
        <h2>疫病净化自评</h2>
      </div>
      <ul class="subject-BioSafety">
        <li @click="subject('swine')">
          <img src="../../assets/subjectimg/icon03.png" alt="">
          <span>伪狂犬病净化</span>
        </li>
        <li @click="subject('rabid')">
          <img src="../../assets/subjectimg/icon04.png" alt="">
          <span>猪瘟</span>
        </li>
        <li @click="subject('blueear')">
          <img src="../../assets/subjectimg/icon05.png" alt="">
          <span>猪蓝耳病</span>
        </li>
      </ul>
      <div class="title">
        <h2>疫病诊断测评</h2>
      </div>
      <ul class="subject-img">
        <li @click="subject('SubjectList','7')">
          <img src="../../assets/subjectimg/icon06.png" alt="">
          <span>猪腹泻疾病</span>
        </li>
        <li @click="subject('SubjectList','8')">
          <img src="../../assets/subjectimg/icon07.png" alt="">
          <span>猪呼吸道疾病</span>
        </li>
        <li @click="subject('SubjectList','6')">
          <img src="../../assets/subjectimg/icon08.png" alt="">
          <span>猪繁殖障碍病</span>
        </li>
        <li @click="subject('SubjectList','4')">
          <img src="../../assets/subjectimg/icon09.png" alt="">
          <span>牛呼吸道疾病</span>
        </li>
        <li @click="subject('SubjectList','5')">
          <img src="../../assets/subjectimg/icon10.png" alt="">
          <span>牛消化道疾病</span>
        </li>
        <li @click="subject('SubjectList','2')">
          <img src="../../assets/subjectimg/icon11.png" alt="">
          <span>鸡呼吸道疾病</span>
        </li>
        <li @click="subject('SubjectList','1')">
          <img src="../../assets/subjectimg/icon12.png" alt="">
          <span>鸡减蛋疾病</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'subject',
  data(){
    return{
      browser: {
        trident: navigator.userAgent.indexOf('Trident') > -1, //IE内核
        presto: navigator.userAgent.indexOf('Presto') > -1, //opera内核
        webKit: navigator.userAgent.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: navigator.userAgent.indexOf('Gecko') > -1 && navigator.userAgent.indexOf('KHTML') == -1, //火狐内核
        mobile: !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/) || !!navigator.userAgent.match(/AppleWebKit/), //是否为移动终端
        ios: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1, //android终端或者uc浏览器
        iPhone: navigator.userAgent.indexOf('iPhone') > -1 || navigator.userAgent.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
        iPad: navigator.userAgent.indexOf('iPad') > -1, //是否iPad
        webApp: navigator.userAgent.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
      },
      user_id: '',
      isWx: 1,
    }
  },
  mounted() {
  },
  created(){
    document.title = '兽医宝库'
    this.user_id = this.$route.query.user_id
    const ua = window.navigator.userAgent.toLowerCase();
    if(ua.indexOf('micromessenger') == -1) {
      this.isWx = 1
    }else{
      this.isWx = 2
    }
    console.log('this.isWx',this.isWx)
    this.getaccessstatus()
  },
  methods: {
    // 浏览记录
    getaccessstatus() {
      let data = {
        user_id: this.user_id,
        page_type: "home"
      }
      this.$store.dispatch('report/getaccessstatus', data)
    },
    // 跳转相对应的路由
    subject(str,examid) {
      console.log('str',str)
      console.log('examid',examid)
      console.log('user_id',this.user_id)
      this.$router.push({
        name: str,
        query:{
          user_id: this.user_id,
          examid: examid,
        }
      })
    },
    // APP返回
    onClickLeft() {
      if (this.browser.android) {
        ZKAPP.back();
      }else {
        window.webkit.messageHandlers.back.postMessage({name: 'zhangyutang', age: 12});
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.hello .van-nav-bar .van-icon{
    color: #999999 !important;
  }
</style>
<style scoped lang="scss">
.subjectlist {
  font-size: 0;
  .title {
    h2 {
      padding-left: 10px;
      font-size: 14px;
      color: #181818;
      font-weight: 500;
      background: #F5F5F5;
      height: 40px;
      line-height: 40px;
      text-align: left;
      font-weight: bold;
    }
  }
  .subject-BioSafety {
    display: flex;
    text-align: center;
    padding: 10px;
    li {
      flex: 1;
      img {
        width: 70px;
        height: 70px;
      }
      span {
        display: block;
        font-size: 12px;
        text-align: center;
      }
    }
  }
  .subject-img {
    display: flex;
    flex-wrap: wrap;
    padding: 10px 0;
    li {
      width: 33.3%;
      text-align: center;
      padding-bottom: 10px;
      img {
        width: 70px;
        height: 70px;
      }
      span {
        display: block;
        font-size: 12px;
        text-align: center;
      }
    }
  }
}
</style>
